import { IRpaConnectUIPathState } from 'app/rpa-bots/core/IRpaBots';
import { EUIPathConnActions, UIPathConnActions } from '../actions/rpa-uipath-conn.actions';

export const initialStateRpaUIPathState: IRpaConnectUIPathState = {
  isLoadingList: false,
  isLoadingDetail: false,
  connectors: [],
  currentConnector: null
}

export function RpaUIPathReducers(state = initialStateRpaUIPathState, action: UIPathConnActions): IRpaConnectUIPathState {
  switch (action.type) {

    case EUIPathConnActions.UIPathConnList: {
      const newState: IRpaConnectUIPathState = {
        ...state,
        isLoadingList: true
      };
      return newState;
    }

    case EUIPathConnActions.UIPathConnListSuccess: {
      const newState: IRpaConnectUIPathState = {
        ...state,
        isLoadingList: false,
        connectors: _.orderBy([...action.payload], (p) => p.name)
      };
      return newState;
    }

    case EUIPathConnActions.getCurrentUIPathConn: {
      const newState: IRpaConnectUIPathState = {
        ...state,
        isLoadingDetail: true
      }
      return newState;
    }

    case EUIPathConnActions.getCurrentUIPathConnSuccess: {
      const newState: IRpaConnectUIPathState = {
        ...state,
        isLoadingDetail: false,
        currentConnector: { ...action.payload }
      }
      return newState;
    }

    case EUIPathConnActions.UpdateUIPathConn: {
      const newState: IRpaConnectUIPathState = {
        ...state,
        isLoadingDetail: true
      }
      return newState;
    }

    case EUIPathConnActions.UpdateUIPathConnSuccess: {
      const newState: IRpaConnectUIPathState = {
        ...state,
        isLoadingDetail: false,
        currentConnector: { ...action.payload }
      }
      return newState;
    }

    case EUIPathConnActions.TestUIPathConn: {
      const newState: IRpaConnectUIPathState = {
        ...state,
        isLoadingDetail: true
      }
      return newState;
    }

    case EUIPathConnActions.TestUIPathConnSuccess: {
      const newState: IRpaConnectUIPathState = {
        ...state,
        isLoadingDetail: false,
        currentConnector: { ...action.payload }
      }
      return newState;
    }

    case EUIPathConnActions.ResetUIPathState: {
      return initialStateRpaUIPathState;
    }

    default: {
      return state;
    }
  }
}
